<template>
  <div class="atividades-monitoramentoacesso ml-4 mr-4" >
      <b-form> 

          <b-row>

             
              <b-col>




                <!-- RE e CELULAR -->     
               
                <b-row >
                  <b-col cols="1" class="mt-4">
                    <label for="input-busca">QTD de dias</label>  
                    <b-form-input 
                      id="fot-registro" 
                      type="number" 
                      min="0" 
                      required                        
                      v-model="registro"                             
                      placeholder="qtd de dias" 
                    />                        
                  </b-col>

                    
            


                <b-col cols=1 class="mt-4">
                    <label  for="input-busca"></label> 
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" block @click="carregando = true,loadAuditoriaAppUltimoAcesso()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>   
                </b-col>

                <b-col cols=1 class="mt-4">
                   <label  for="input-busca"></label> 
                       
                <b-button  variant="success" class="mr-2 mt-2" block @click="gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>


                <b-col cols="5">
                    <b-col class="mb-0 mt-4">
                        <label  for="input-busca">Filtrar no grid  </label>  
                        <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Registro / Programa / Observações"></b-form-input>              
                    </b-col>                 
                </b-col>


                <LoadingModal v-if="isLoading" />
             
                </b-row>

                          <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE FUNCIONÁRIOS"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    

                      {{ itemsFiltered.length  }}

                      
                  
                  </h2>
                </b-card-text>
              </b-card>   


        </b-card-group> 

                            


              </b-col>              
          </b-row>

          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="888px"  :items="itemsFiltered" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            isLoading: false,
            carregando: false,
            filtro: false,
            operadores:{},
            operador: [],            
            acesso:[],
            data_operacao: '',
            search:'',

            




            mainProps: { blankColor: '#777', width: 157, height: 161, class: 'm1' },


            
            fields: [
                

              { key: 'filial', label: 'Filial', sortable: true },
                { key: 'ultimo_acesso	', label: 'Data ultimo acesso', sortable: true, formatter: (value, key, itemsFiltered) => {
                    return moment(itemsFiltered.ultimo_acesso).format('DD/MM/YYYY HH:mm');} },
                { key: 'registro', label: 'Registro', sortable: true },           
                { key: 'funcao', label: 'Função', sortable: true },           
                { key: 'situacao', label: 'Situação', sortable: true },                 
                
                

            //    { key: 'observacoes', label: 'Observações', sortable: true },
           //     { key: 'ip', label: 'IP de acesso', sortable: true },
               

               
                
            ]
        }        
    },

    //computed: mapState(['user']),
        computed : { ... mapState (['user'],),
    
      itemsFiltered(){
        let valores = [];       
        valores = this.acesso.filter((item) =>{ 
          const registro = item.registro || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const funcao = item.funcao || '';
          
          
           return (
            registro.toLowerCase().includes(this.search.toLowerCase()) ||            
            funcao.toLowerCase().includes(this.search.toLowerCase())                         
          );
        });
           return valores
        },

   
    } ,

    components: {LoadingModal    },
    methods: {

            formatObservacoes(value) {
      return value == null ? '-' : value;
    },


        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.acesso

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'apps_auditoriaUltimoAcesso.xlsx');
      },

async loadAuditoriaAppUltimoAcesso() { 
  this.isLoading = true; // Ative o indicador de carregamento                                    
  let corpo = {                
    "empresa_id": `${this.user.id_empresa}`,
    "qtdDias": `${this.registro}`,    
  }; 
  const url = `${baseApiUrl}/informatica/appaultimoacesso`;
  
  try {
    const res = await axios.post(url, corpo);

    if (res.status === 200) {  // Verifique diretamente res.status, sem "response"
      this.isLoading = false; // Desative o indicador de carregamento
      this.carregando = false;
      this.acesso = res.data; // Atribua os dados de auditoria
      //this.registro = '';     // Limpe o campo de registro
    } else {
      console.log('Erro na resposta:', res);
    }
  } catch (error) {
    this.isLoading = false; // Desative o indicador de carregamento em caso de erro
    showError(error); // Função para exibir o erro
  }
}



        
       
    },

    mounted() { 
       // this.loadFormatarData()
       //this.loadOperador()           
       //this.loadAuditoriaAppUltimoAcesso()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>

